import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { FaFacebook, FaDiscord, FaTelegram, FaXTwitter } from "react-icons/fa6";
import { IoIosLink } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { getAirDropAction, submitAirdropLinks } from "../../Action/user.action";
import toast, { Toaster } from "react-hot-toast";
import Dashboardheader from "../../directives/dashboardheader";

const Airdrop = () => {
  const navigate = useNavigate();
  const [startTime, setStartTime] = useState(null);
  const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000; // 7 din milliseconds

  const [timeLeft, setTimeLeft] = useState(SEVEN_DAYS);

  useEffect(() => {
    if (!startTime) return; // startTime nahi aaya toh wait karo

    const interval = setInterval(() => {
      const now = Date.now();
      const remaining = SEVEN_DAYS - (now - startTime);
      setTimeLeft(remaining > 0 ? remaining : 0);
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const days = Math.floor(totalSeconds / (24 * 3600));
    const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${days}d ${hours.toString().padStart(2, "0")}h:${minutes
      .toString()
      .padStart(2, "0")}m:${seconds.toString().padStart(2, "0")}s`;
  };

  const [cardData1, setCardData] = useState({});
  const [userLinks, setUserLinks] = useState({});

  useEffect(() => {
    getCardData();
  }, []);

  const handleLinkChange = (fieldName, value) => {
    setUserLinks((prev) => ({ ...prev, [fieldName]: value }));
  };

  const getCardData = async () => {
    try {
      const res = await getAirDropAction();
      if (!res.success || !res.data || res.data.length === 0) {
        navigate("/dashboard");
        return;
      }
      setCardData(res.data[0]);
      setStartTime(new Date("2025-10-25T12:00:00.000Z").getTime());
    } catch (error) {
      console.error(error);
      // navigate("/dashboard");
    }
  };

  const cardData = [
    {
      id: 1,
      fieldName: "facebook_link",
      icon: <FaFacebook style={{ width: 50, height: 50, color: "#1877f2" }} />,
      title: "Task 1: Re-Share the 'Anannta Blockchain' status on Facebook",
      subtitle: "Complete the following steps:",
      link: cardData1.facebook,
      steps: [
        ({ link }) => (
          <>
            Visit our official{" "}
            <a href={link} target="_blank" rel="noopener noreferrer">
              "Anannta BlockChain"
            </a>{" "}
            page on Facebook.
          </>
        ),
        "Reshare Status on your profile status.",
        "Copy the link of your status and paste it below.",
      ],
    },
    {
      id: 2,
      fieldName: "x_link",
      icon: <FaXTwitter style={{ width: 50, height: 50, color: "white" }} />,
      title: "Task 2: Repost & Engage on Twitter/X",
      subtitle: "Complete the following steps:",
      link: cardData1.x,
      steps: [
        ({ link }) => (
          <>
            Follow{" "}
            <a href={link} target="_blank" rel="noopener noreferrer">
              "Anannta BlockChain"
            </a>{" "}
            page on X.
          </>
        ),
        "If you don't have an account,then create it.",
        "Now Repost the pinned post.",
        "Copy the URL of your repost and submit below.",
      ],
    },
    {
      id: 3,
      fieldName: "telegram_link",
      icon: <FaTelegram style={{ width: 50, height: 50, color: "#0088cc" }} />,
      title: "Task 3: Join our official Telegram Channel",
      subtitle: "Complete the following steps:",
      link: cardData1.telegram,
      steps: [
        ({ link }) => (
          <>
            Click on the{" "}
            <a href={link} target="_blank" rel="noopener noreferrer">
              link
            </a>{" "}
            and Join the Group.
          </>
        ),
        // 'Drop the message "I am really excited to be part of Annanta BlockChain Community" in the group.',
      ],
    },
    {
      id: 4,
      fieldName: "discord_link",
      icon: <FaDiscord style={{ width: 50, height: 50, color: "#5865f2" }} />,
      title: "Task 4: Join our official Discord Channel",
      subtitle: "Complete the following steps:",
      link: cardData1.discord,
      steps: [
        ({ link }) => (
          <>
            Open this{" "}
            <a href={link} target="_blank" rel="noopener noreferrer">
              link
            </a>{" "}
            and accept the invite by clicking "Join".
          </>
        ),
        'Send a message "I am really excited to be part of Annanta BlockChain Community" in the Channel.',
      ],
    },
  ];

  const handleSubmit = async () => {
    const emptyField = cardData
      .filter((task) => task.fieldName === "facebook_link" || task.fieldName === "x_link")
      .some(
        (task) =>
          !userLinks[task.fieldName] || userLinks[task.fieldName].trim() === ""
      );

    if (emptyField) {
      toast.error("Please fill in Facebook and Twitter/X links before submitting!");
      return;
    }

    try {
      const payload = {
        facebook_link: userLinks.facebook_link || "",
        x_link: userLinks.x_link || "",
        telegram_link: userLinks.telegram_link || "",
        discord_link: userLinks.discord_link || "",
        step_balance: cardData1.step_balance || 0,
        vesting_balance: cardData1.vesting_balance || 0,
        business_balance: cardData1.business_balance || 0,
      };
      const res = await submitAirdropLinks(payload);
      if (res.success) {
        toast.success(res.msg);
        setTimeout(() => {
          navigate("/dashboard");
        }, 1500);
      } else {
        toast.error(res.msg);
      }
    } catch (error) {
      console.error(error);
      toast.error("Error submitting links.");
    }
  };

  return (
    <>
      <Toaster />
      <div className="color-container">
        <div className="new-home-section3 airdrop-container">
          <div className="c1"></div>
          <div className="c2"></div>
          <div className="c3"></div>
          <div className="c4"></div>

          <Container className="align-items-center w-100 sofia-sans">
            <Dashboardheader />

            <div className="content-div w-100 d-flex justify-content-center flex-column align-items-center py-5 px-3">
              <h2
                className="text-center pt-5 font-bold text-white sofia-sans"
                style={{ fontWeight: 600, fontSize: 40 }}
              >
                Earn ANANT Coin by participating in StepMint Airdrop :{" "}
              </h2>
              <p
                className="text-center pt-2  sofia-sans"
                style={{ fontSize: 16, maxWidth: 800 }}
              >
                The objective of this airdrop is to target users who have a
                total balance of 100 MNT or less across all wallets. Eligible
                users will receive ANANT Coins through an airdrop, which will be
                distributed 7 days after the start of the program. This program
                will remain active for 7 days only. To qualify, users must
                complete all the activities listed below. Once all activities
                are verified, the user will be considered qualified for the
                airdrop and will receive it accordingly.
              </p>

              <br />
              <motion.div
                className="p-3 rounded-3 text-white sofia-sans fw-bold"
                style={{
                  background: "rgba(255,255,255,0.05)",
                  letterSpacing: "1px",
                  fontSize: "26px",
                }}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                ⏳ Time left:{" "}
                <motion.span
                  key={timeLeft}
                  initial={{ scale: 0.8 }}
                  animate={{ scale: 1 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  {formatTime(timeLeft)}
                </motion.span>
              </motion.div>
              <br />
              <p
                className="text-center pt-2  sofia-sans text-white"
                style={{ fontSize: 24 }}
              >
                Complete the following tasks and unlock your MNT Token to ANANT
                Coin{" "}
              </p>
              <br />
              <Row
                className="cards-div text-white"
                style={{ width: "100%", maxWidth: 1000 }}
              >
                {cardData.map((task) => (
                  <Col key={task.id} lg={6} className="mb-4 text-center">
                    <motion.div
                      className="airdrop-card p-4 h-100 rounded-4 shadow-lg"
                      style={{
                        background: "rgba(30, 30, 30, 0.8)",
                        backdropFilter: "blur(10px)",
                        border: "1px solid rgba(255,255,255,0.1)",
                      }}
                      whileHover={{
                        scale: 1.01,
                        boxShadow: "0 0 25px rgba(255,255,255,0.1)",
                      }}
                    >
                      <div className="d-flex gap-3 align-items-start">
                        <motion.div
                          whileHover={{ rotate: 10 }}
                          transition={{ type: "spring", stiffness: 300 }}
                        >
                          {task.icon}
                        </motion.div>

                        <div className="text-start">
                          <h5 className="text-white sofia-sans mb-2">
                            <span
                              style={{
                                fontWeight: "bold",
                                fontSize: 15,
                                color: "#fff",
                              }}
                            >
                              {task.title}
                            </span>
                            <br />
                            {/* <span style={{ fontSize: 12, color: "#bdbdbd" }}>{task.subtitle}</span> */}
                          </h5>

                          <div
                            className="sofia-sans text-light"
                            style={{ fontSize: 14 }}
                          >
                            {task.steps.map((step, i) => (
                              <p key={i} className="mb-1 text-white">
                                {i + 1} -{" "}
                                {typeof step === "function"
                                  ? step({ link: task.link })
                                  : step}
                              </p>
                            ))}
                          </div>
                        </div>
                      </div>

                      {(task.id === 1 || task.id === 2) && (
                        <motion.div
                          className="d-flex align-items-center gap-3 mt-4 p-1 px-3 rounded-3"
                          style={{
                            background: "rgba(255,255,255,0.05)",
                            border: "1px solid rgba(255,255,255,0.1)",
                          }}
                          whileHover={{
                            background: "rgba(255,255,255,0.1)",
                            transition: { duration: 0.3 },
                          }}
                        >
                          <motion.div
                            className="d-flex justify-content-center align-items-center rounded-circle"
                            style={{
                              width: 35,
                              height: 35,
                              background:
                                "linear-gradient(135deg, #00b4d8, #0077b6)",
                              boxShadow: "0 0 10px rgba(0,180,216,0.5)",
                            }}
                            whileHover={{ rotate: 20 }}
                            transition={{ type: "spring", stiffness: 300 }}
                          >
                            <IoIosLink
                              style={{ width: 16, height: 16, color: "#fff" }}
                            />
                          </motion.div>

                          <Form.Group
                            controlId={`formLink${task.id}`}
                            className="flex-grow-1"
                          >
                            <Form.Control
                              type="url"
                              placeholder="Paste your link here..."
                              className="sofia-sans bg-transparent border-0 text-white"
                              style={{ outline: "none", boxShadow: "none" }}
                              value={userLinks[task.fieldName] || ""}
                              onChange={(e) =>
                                handleLinkChange(task.fieldName, e.target.value)
                              }
                            />
                          </Form.Group>
                        </motion.div>
                      )}
                    </motion.div>
                  </Col>
                ))}
              </Row>
              <div className="d-flex gap-2">
                <Button
                  variant="main2"
                  className="mt-auto sofia-sans text-white px-4 w-100"
                  style={{ minWidth: 200 }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Airdrop;
